import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

/**
 * Handles the redirect from Emergent-managed Google Auth.
 * URL format: /auth/callback#session_id=<SESSION>
 * We parse the fragment, POST it to /api/auth/google/session, then redirect
 * to the dashboard (or `state.from` if coming from a protected route).
 */
export default function AuthCallback() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | error
  const [error, setError] = useState("");

  useEffect(() => {
    const frag = window.location.hash || "";
    const m = frag.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : "";
    if (!sessionId) {
      setStatus("error");
      setError("No se recibió session_id de Google.");
      return;
    }

    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        await refresh();
        // Clear the fragment + redirect
        window.history.replaceState({}, "", "/auth/callback");
        nav("/dashboard", { replace: true });
      } catch (e) {
        setStatus("error");
        setError(e.response?.data?.detail || e.message || "Error de sesión");
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center p-8" data-testid="auth-callback-page">
      {status === "loading" ? (
        <>
          <Loader2 size={24} className="animate-spin mb-4" style={{ color: "var(--brand-primary)" }} />
          <p className="text-sm" style={{ color: "var(--text-secondary)" }}>
            Validando tu cuenta de Google…
          </p>
        </>
      ) : (
        <>
          <p className="font-serif text-2xl mb-2" style={{ color: "#ef6d6d" }}>No pudimos iniciar sesión</p>
          <p className="text-sm mb-6" style={{ color: "var(--text-secondary)" }}>{error}</p>
          <a href="/login" className="btn-primary text-xs">Volver a intentar</a>
        </>
      )}
    </div>
  );
}
